/** `1d 2h 30m`, `1.5h`, `90m`, `45` (minutes) → minutes; YouTrack's day is 8 hours. null when unreadable. */
export function parsePeriod(text: string): number | null {
  const s = text.trim().toLowerCase();
  if (!s) return null;
  if (/^\d+$/.test(s)) return Number(s);
  let total = 0;
  let matched = false;
  for (const m of s.matchAll(/(\d+(?:\.\d+)?)\s*(w|d|h|m|min|mins|hours?|days?|weeks?|minutes?)\b/g)) {
    matched = true;
    const n = Number(m[1]);
    const u = m[2]![0];
    total += u === "w" ? n * 5 * 480 : u === "d" ? n * 480 : u === "h" ? n * 60 : n;
  }
  if (!matched) return null;
  const rest = s.replace(/(\d+(?:\.\d+)?)\s*(w|d|h|m|min|mins|hours?|days?|weeks?|minutes?)\b/g, "").trim();
  if (rest) return null;
  return Math.round(total) || null;
}
